import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateUserActivityMutationVariables = Types.Exact<{
  userId: Types.Scalars['bigint']['input'];
}>;


export type UpdateUserActivityMutation = { __typename?: 'mutation_root', update_users_by_pk?: { __typename?: 'users', id: number, last_active_at?: string | null } | null };


export const UpdateUserActivityDocument = gql`
    mutation updateUserActivity($userId: bigint!) {
  update_users_by_pk(pk_columns: {id: $userId}, _set: {last_active_at: "now()"}) {
    id
    last_active_at
  }
}
    `;
export type UpdateUserActivityMutationFn = Apollo.MutationFunction<UpdateUserActivityMutation, UpdateUserActivityMutationVariables>;

/**
 * __useUpdateUserActivityMutation__
 *
 * To run a mutation, you first call `useUpdateUserActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserActivityMutation, { data, loading, error }] = useUpdateUserActivityMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateUserActivityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserActivityMutation, UpdateUserActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserActivityMutation, UpdateUserActivityMutationVariables>(UpdateUserActivityDocument, options);
      }
export type UpdateUserActivityMutationHookResult = ReturnType<typeof useUpdateUserActivityMutation>;
export type UpdateUserActivityMutationResult = Apollo.MutationResult<UpdateUserActivityMutation>;
export type UpdateUserActivityMutationOptions = Apollo.BaseMutationOptions<UpdateUserActivityMutation, UpdateUserActivityMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/auth/queries/updateUserActivity.mutation.gql}
 */
export async function updateUserActivity(
  variables: UpdateUserActivityMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateUserActivityMutation['update_users_by_pk']>
export async function updateUserActivity(
  variables: UpdateUserActivityMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateUserActivityMutation>
export async function updateUserActivity(
  variables: UpdateUserActivityMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateUserActivityMutation['update_users_by_pk'] | UpdateUserActivityMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateUserActivityMutation>(
    UpdateUserActivityDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_users_by_pk
}